

// import { useState, useEffect } from "react";
// import axios from "axios";
// import { toast } from "react-toastify";
// import LoadSpinner from "../../../component/Modals/LoadSpinner";
// import { io } from "socket.io-client";

// const EmployerUrgentRequestForm = () => {
//   const [formData, setFormData] = useState({
//     userId: localStorage.getItem("userId"),
//     position: "",
//     durationType: "hours",
//     durationValue: 1,
//     benefits: [],
//     otherBenefit: "",
//   });
//   const [loading, setLoading] = useState(false);
//   const [amount, setAmount] = useState(0);

//   const positionRates = {
//     "Accountant": 5000,
//     "Carpenter": 3000,
//     "Cleaner": 2000,
//     "Driver": 2500,
//     "Electrician": 4000,
//     "Gardener": 2000,
//     "Mechanic": 3500,
//     "Nurse": 4500,
//     "Plumber": 3000,
//     "Teacher": 4000,
//     "web developer": 700000,
//     "software developer": 400000,
//     "software engineer": 600000,
//   };

//   useEffect(() => {
//     const baseRate = positionRates[formData.position] || 2000;
//     let calculatedAmount = 0;
//     if (formData.durationType === "hours") {
//       calculatedAmount = baseRate * formData.durationValue;
//     } else if (formData.durationType === "days") {
//       calculatedAmount = baseRate * formData.durationValue * 0.8;
//     } else if (formData.durationType === "weeks") {
//       calculatedAmount = baseRate * formData.durationValue * 0.6 * 7;
//     }
//     setAmount(calculatedAmount);
//   }, [formData.position, formData.durationType, formData.durationValue]);

//   useEffect(() => {
//     const socket = io(process.env.REACT_APP_API_URL, { query: { userId: formData.userId } });

//     socket.on("newUrgentRequest", (request) => {
//       if (request.userId === formData.userId) {
//         toast.success(`Your urgent job request for ${request.position} was created successfully`);
//       }
//     });

//     return () => {
//       socket.off("newUrgentRequest");
//       socket.disconnect();
//     };
//   }, [formData.userId]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!formData.position) {
//       toast.error("Please select or enter a position");
//       return;
//     }
//     if (formData.benefits.includes("others") && !formData.otherBenefit) {
//       toast.error("Please specify other benefit");
//       return;
//     }
//     setLoading(true);
//     try {
//       await axios.post(
//         `${process.env.REACT_APP_API_URL}urgent/create-urgent-request`,
//         formData,
//         { headers: { Authorization: `Bearer ${localStorage.getItem("token") || ""}` } }
//       );
//       setFormData({ ...formData, position: "", durationValue: 1, benefits: [], otherBenefit: "" });
//     } catch (error) {
//       toast.error(error.response?.data?.message || "Error creating request");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="p-6 max-w-2xl mx-auto">
//       <h2 className="text-2xl font-bold mb-6">Create Urgent Staff Request</h2>
//       <form onSubmit={handleSubmit} className="space-y-4">
//         <div>
//           <label className="block text-sm font-medium text-gray-700">Position</label>
//           <select
//             value={formData.position}
//             onChange={(e) => setFormData({ ...formData, position: e.target.value })}
//             className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
//           >
//             <option value="">Select a position</option>
//             {Object.keys(positionRates).sort().map((pos) => (
//               <option key={pos} value={pos}>{pos}</option>
//             ))}
//             <option value="other">Other (Type below)</option>
//           </select>
//           {formData.position === "other" && (
//             <input
//               type="text"
//               value={formData.position === "other" ? "" : formData.position}
//               onChange={(e) => setFormData({ ...formData, position: e.target.value })}
//               className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
//               placeholder="Enter custom position"
//             />
//           )}
//         </div>
//         <div>
//           <label className="block text-sm font-medium text-gray-700">Duration Type</label>
//           <select
//             value={formData.durationType}
//             onChange={(e) => setFormData({ ...formData, durationType: e.target.value })}
//             className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
//           >
//             <option value="hours">Hours</option>
//             <option value="days">Days</option>
//             <option value="weeks">Weeks</option>
//           </select>
//         </div>
//         <div>
//           <label className="block text-sm font-medium text-gray-700">Duration Value</label>
//           <input
//             type="number"
//             min="1"
//             value={formData.durationValue}
//             onChange={(e) => setFormData({ ...formData, durationValue: parseInt(e.target.value) || 1 })}
//             className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
//           />
//         </div>
//         <div>
//           <label className="block text-sm font-medium text-gray-700">Benefits</label>
//           <div className="space-y-2">
//             {["Health Insurance", "Transportation", "Meal Allowance", "others"].map((benefit) => (
//               <div key={benefit} className="flex items-center">
//                 <input
//                   type="checkbox"
//                   value={benefit}
//                   checked={formData.benefits.includes(benefit)}
//                   onChange={(e) => {
//                     const newBenefits = formData.benefits.includes(e.target.value)
//                       ? formData.benefits.filter((b) => b !== e.target.value)
//                       : [...formData.benefits, e.target.value];
//                     setFormData({ ...formData, benefits: newBenefits });
//                   }}
//                   className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
//                 />
//                 <span className="ml-2 text-sm text-gray-700">{benefit}</span>
//               </div>
//             ))}
//             {formData.benefits.includes("others") && (
//               <input
//                 type="text"
//                 value={formData.otherBenefit}
//                 onChange={(e) => setFormData({ ...formData, otherBenefit: e.target.value })}
//                 className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
//                 placeholder="Specify other benefit"
//               />
//             )}
//           </div>
//         </div>
//         <div>
//           <label className="block text-sm font-medium text-gray-700">Amount</label>
//           <input
//             type="text"
//             value={`N${amount}`}
//             readOnly
//             className="mt-1 block w-full border-gray-300 rounded-md shadow-sm bg-gray-100"
//           />
//         </div>
//         <button
//           type="submit"
//           className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition"
//           disabled={loading}
//         >
//           {loading ? <LoadSpinner /> : "Submit Request"}
//         </button>
//       </form>
//     </div>
//   );
// };

// export default EmployerUrgentRequestForm;




import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useSocket } from "../../../hooks/useSocket";
import LoadSpinner from "../../../component/Modals/LoadSpinner";

const EmployerUrgentRequestForm = () => {
  const [formData, setFormData] = useState({
    userId: localStorage.getItem("userId"),
    position: "",
    durationType: "hours",
    durationValue: 1,
    benefits: [],
    otherBenefit: "",
  });
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState(0);
  const token = localStorage.getItem("token");
  const { socket } = useSocket();

  const positionRates = {
    Accountant: 5000,
    Carpenter: 3000,
    Cleaner: 2000,
    Driver: 2500,
    Electrician: 4000,
    Gardener: 2000,
    Mechanic: 3500,
    Nurse: 4500,
    Plumber: 3000,
    Teacher: 4000,
    "Web Developer": 700000,
    "Software Developer": 400000,
    "Software Engineer": 600000,
  };

  useEffect(() => {
    const baseRate = positionRates[formData.position] || 2000;
    let calculatedAmount = 0;
    switch (formData.durationType) {
      case "hours":
        calculatedAmount = baseRate * formData.durationValue;
        break;
      case "days":
        calculatedAmount = baseRate * formData.durationValue * 0.8;
        break;
      case "weeks":
        calculatedAmount = baseRate * formData.durationValue * 0.6 * 7;
        break;
      default:
        break;
    }
    setAmount(calculatedAmount);
  }, [formData.position, formData.durationType, formData.durationValue]);

  useEffect(() => {
    if (socket) {
      socket.on("newUrgentRequest", (request) => {
        if (request.userId === formData.userId) {
          toast.success(`Request for ${request.position} created`);
        }
      });
    }
    return () => {
      if (socket) socket.off("newUrgentRequest");
    };
  }, [socket, formData.userId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.position) {
      toast.error("Please select or enter a position");
      return;
    }
    if (formData.benefits.includes("others") && !formData.otherBenefit) {
      toast.error("Please specify other benefit");
      return;
    }
    setLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}urgent/create-urgent-request`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("Request created successfully");
      setFormData({ ...formData, position: "", durationValue: 1, benefits: [], otherBenefit: "" });
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to create request");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-md p-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">Create Urgent Staff Request</h2>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Position</label>
            <select
              value={formData.position}
              onChange={(e) => setFormData({ ...formData, position: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Select a position</option>
              {Object.keys(positionRates).map((pos) => (
                <option key={pos} value={pos}>
                  {pos}
                </option>
              ))}
              <option value="other">Other</option>
            </select>
            {formData.position === "other" && (
              <input
                type="text"
                onChange={(e) => setFormData({ ...formData, position: e.target.value })}
                className="mt-2 w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                placeholder="Enter custom position"
              />
            )}
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Duration Type</label>
            <select
              value={formData.durationType}
              onChange={(e) => setFormData({ ...formData, durationType: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
            >
              <option value="hours">Hours</option>
              <option value="days">Days</option>
              <option value="weeks">Weeks</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Duration Value</label>
            <input
              type="number"
              min="1"
              value={formData.durationValue}
              onChange={(e) => setFormData({ ...formData, durationValue: parseInt(e.target.value) || 1 })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Benefits</label>
            <div className="space-y-2">
              {["Health Insurance", "Transportation", "Meal Allowance", "others"].map((benefit) => (
                <div key={benefit} className="flex items-center">
                  <input
                    type="checkbox"
                    value={benefit}
                    checked={formData.benefits.includes(benefit)}
                    onChange={(e) => {
                      let benefits = [...formData.benefits];
                      if (e.target.checked) {
                        benefits.push(benefit);
                      } else {
                        benefits = benefits.filter((b) => b !== benefit);
                      }
                      setFormData({ ...formData, benefits });
                    }}
                    className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                  />
                  <span className="ml-2 text-sm text-gray-600">{benefit}</span>
                </div>
              ))}
              {formData.benefits.includes("others") && (
                <input
                  type="text"
                  value={formData.otherBenefit}
                  onChange={(e) => setFormData({ ...formData, otherBenefit: e.target.value })}
                  className="mt-2 w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                  placeholder="Specify other benefit"
                />
              )}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Amount</label>
            <input
              type="text"
              value={`N${amount}`}
              readOnly
              className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100"
            />
          </div>
          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition disabled:bg-blue-400"
            disabled={loading}
          >
            {loading ? <LoadSpinner /> : "Submit Request"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EmployerUrgentRequestForm;